import {BCMSRecord ,BCMSRecordProperty} from "bcms-react"; 

/**
* @class Timezone
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.timezones[0];
* const contactInfo = new Timezone(record);
* @property {NUMBER} _id - The id of the timezone.
* @property {STRING} _value - The value of the timezone, like "Central Standard Time"
*/
export default class Timezone extends BCMSRecord {
    _id
    _value
    constructor (record){     
      super(record) 
    }

    static getByValue(value) {
      return Timezone.initAll().find(zone => zone.value === value, []);
    }
  }
  Timezone.define({
    "recordType":"timezones",
    "recordIDProp":"id",
    "className" : "Timezone",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id of the timezone
       * @property set {NUMBER} - sets the id of the timezone
       * @memberof Timezone
       */
      BCMSRecordProperty.mapToNumber("id","_id"),
      /** 
       * @name type
       * @instance
       * @property get {STRING} - gets the value of the timezone, like "Central Standard Time"
       * @property set {STRING} - sets the value of the timezone, like "Central Standard Time"
       * @memberof Timezone
       */
      BCMSRecordProperty.mapToString("value","_value")
    ]  
})




